import { seededRoles } from '@featit/shared/i18n/messages/en/seededRoles';
import type { TFn } from '@/i18n/LocaleProvider';

type SeededRoleKeyType = keyof typeof seededRoles.names;

export const isSeededRoleKey = (key: string): key is SeededRoleKeyType =>
  Object.prototype.hasOwnProperty.call(seededRoles.names, key);

/**
 * I-1977: a role's name as a screen says it, without putting the `seededRoles` English area in the
 * catalogue. `seededRoleWords` registers that area for the screens that draw roles; a module the launch
 * entry reaches (`roleRefusalReason`) reads this one instead, so the area stays out of the entry chunk
 * (F-0621, `entryAreas.guard.test.ts`). `t` must be able to read `seededRoles.*`: a loaded language
 * other than English, or English once a role screen has registered the area.
 */
export function seededRoleWordsIn(t: TFn, role: { key: string | null; name: string }): string {
  return role.key && isSeededRoleKey(role.key) && seededRoles.names[role.key] === role.name
    ? t(`seededRoles.names.${role.key}`)
    : role.name;
}
